import { FullscreenOverlayContainer } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EsteiraApuracaoComponent } from './esteira-apuracao.component';

const routes: Routes = [
  {
    path: '',
    component: EsteiraApuracaoComponent,
    title: 'Esteira de Apuração',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EsteiraApuracaoRoutingModule {}
